import React from 'react';
import PropTypes from 'prop-types';
import { ContentSection } from './styles';

const NodeContentSection = ({ description, type, contextId }) => {
  return (
    <ContentSection
      className="content-section voice-content"
      data-selection-entity={type}
      data-selection-uuid={contextId}
      dangerouslySetInnerHTML={{ __html: description }}
    />
  );
};

export default NodeContentSection;

NodeContentSection.propTypes = {
  description: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  contextId: PropTypes.string.isRequired,
};
